import { Navigate, Route } from "react-router-dom";

import { routes } from "constants/routes";
import LoadManage from "features/main/Loads";
import LoadDetail from "features/main/Loads/Detail";
import LaneRateTrend from "features/main/Loads/Detail/LaneRateTrend";
import LoadPostMain from "features/main/Loads/List";
import LoadPostedList from "features/main/Loads/List/All";
import HaulPayLoads from "features/main/Loads/List/HaulPay";
import LoadPostCreate from "features/main/Loads/Post/Create";
import CreateBrokerFR from "features/main/Loads/Post/FundingRequest";
import LoadSearch from "features/main/Loads/Search";
import useDeviceType from "hooks/useDeviceType";
import { useUserFeature } from "hooks/useUserFeature";

export default function LoadsRoutes() {
  const { isDesktop } = useDeviceType();
  const { isShipper, isCarrier } = useUserFeature();

  return (
    <Route path={routes.LOADS}>
      {!isDesktop && <Route index element={<LoadManage />} />}

      {!isShipper && (
        <Route path="search">
          <Route path="" element={<LoadSearch />} />
        </Route>
      )}
      {!isCarrier && (
        <Route path="post" element={<LoadPostMain />}>
          <Route path="" element={<Navigate to="all" />} />
          <Route path="all" element={<LoadPostedList />} />
          <Route path="haulpay" element={<HaulPayLoads />} />
        </Route>
      )}

      {!isShipper && (
        <Route path="search">
          <Route path=":loadId">
            <Route path="" element={<LoadDetail />} />
            <Route path="lane-trends" element={<LaneRateTrend />} />
          </Route>
        </Route>
      )}

      {!isCarrier && (
        <Route path="post">
          <Route path=":loadId">
            <Route path="" element={<LoadDetail />} />
            <Route path="lane-trends" element={<LaneRateTrend />} />
          </Route>

          <Route path="create" element={<LoadPostCreate />} />
          <Route path="edit/:postedId" element={<LoadPostCreate />} />

          <Route path="create/funding-request" element={<CreateBrokerFR />} />
        </Route>
      )}
    </Route>
  );
}
